import React from 'react';
import BotaoContato from '../../components/BotaoContato';
import styles from '../NossasSolucoes.module.css';
import { columnClasses } from './../../sharedProperties';

function CloudServerParte5() {
    return (
        <div className="container" style={{ margin: "0px", maxWidth: "100%" }} >
            <div className="row" >
                <div className={`${columnClasses.colDesk1Mob2} ${styles.nossasSolucoes}`}
                    style={{ textAlign: 'center'}}>
                    <img src="/roboCloudServer.gif" alt="Robô VPN-IP" className={`${styles.gifDoRobo}`} />
                </div>
                <div className={`${columnClasses.colDesk2Mob1} ${styles.nossasSolucoes}`}
                    style={{ background: `url("/fundoCloudServer/cloudServer_fundo_parte5_direita.png")` }}>
                    <div className={`d-flex flex-column justify-content-center ${styles.nossasSolucoes} ${styles.sobreNosTexto}`}>
                        <h1>Migre para a</h1>
                        <h1>nuvem com</h1>
                        <h1>confiança</h1>
                        <p>
                            Transforme a infraestrutura de TI da sua empresa hoje mesmo com a <span>AMZ SYSTEM</span>. Consulte um dos nossos especialistas e descubra como podemos impulsionar seu negócio para o futuro digital. 
                        </p>
                        <BotaoContato text="CONSULTAR ESPECIALISTA" />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CloudServerParte5;